 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-img-entry-js","22":"stencil-ion-infinite-scroll_2-ios-entry-js","23":"stencil-ion-infinite-scroll_2-md-entry-js","24":"stencil-ion-input-ios-entry-js","25":"stencil-ion-input-md-entry-js","26":"stencil-ion-loading-ios-entry-js","27":"stencil-ion-loading-md-entry-js","28":"stencil-ion-popover-ios-entry-js","29":"stencil-ion-popover-md-entry-js","30":"stencil-ion-progress-bar-ios-entry-js","31":"stencil-ion-progress-bar-md-entry-js","32":"stencil-ion-radio_2-ios-entry-js","33":"stencil-ion-radio_2-md-entry-js","34":"stencil-ion-reorder_2-ios-entry-js","35":"stencil-ion-reorder_2-md-entry-js","36":"stencil-ion-ripple-effect-entry-js","37":"stencil-ion-spinner-entry-js","38":"stencil-ion-split-pane-ios-entry-js","39":"stencil-ion-split-pane-md-entry-js","40":"stencil-ion-tab-bar_2-ios-entry-js","41":"stencil-ion-tab-bar_2-md-entry-js","42":"stencil-ion-tab_2-entry-js","43":"stencil-ion-text-entry-js","44":"stencil-ion-textarea-ios-entry-js","45":"stencil-ion-textarea-md-entry-js","46":"stencil-ion-toggle-ios-entry-js","47":"stencil-ion-toggle-md-entry-js","48":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"998625aa","1":"baf795aa","2":"6b949194","3":"7a7fccae","4":"c1605246","5":"f13d6603","8":"d81190d9","9":"38c2b4f2","10":"66f2d82f","11":"4bd9e077","12":"4b72297b","13":"81bbaff4","14":"59d094af","15":"611c1528","16":"b2a63850","17":"23233ccc","18":"721746e7","19":"13165c9e","20":"47b55daf","21":"fc56d6bb","22":"438d44db","23":"94617c79","24":"6b323a1a","25":"5a8c549e","26":"abbbb659","27":"f4d21294","28":"82a1d0fc","29":"70e0357d","30":"ff0b2487","31":"53c58a87","32":"45ebc557","33":"71168acf","34":"8b83af04","35":"668a66b6","36":"d1381e6c","37":"a164a259","38":"100b9f8a","39":"f9769249","40":"162483cd","41":"196d9c66","42":"bba5082a","43":"51373d5d","44":"059706d5","45":"c73596ce","46":"467dd184","47":"af7cb207","48":"bdcec8e8","50":"3c59ef7c","51":"343e0b58","52":"5de15aee","53":"c11fd076","54":"08d6fc21","55":"4dbe5b0a","56":"68504d85","57":"a06e7071","58":"e129a26f","59":"3c6bad03","60":"ed1216e5","61":"418e09fe","62":"0e5de8c5","63":"f91eefe2","64":"82b86960","65":"4ebe17f5","66":"6b2dec94","67":"19328645","68":"e7494852","69":"986e6496","70":"b8e5ff82","71":"fddf842b","72":"977c4a54","73":"74aa032a","74":"862048cc","75":"c743c248","76":"ee862f0e","77":"158f30b4","78":"ebbc9011","79":"5421388a","80":"4231c26d","81":"88c083f8","82":"b5d10609","83":"0ac57bbf","84":"c0d164d9","85":"a74330cd","86":"c5a81f03","87":"37a70856","88":"0a605eb0","89":"b9fc354d","90":"fc8c4c9e","91":"9f848cb9"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpresilience-ppe"] = this["webpackJsonpresilience-ppe"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
